// extracted by mini-css-extract-plugin
module.exports = {"error":"ApolloProvider_error__K_tf3","hasError":"ApolloProvider_hasError__LMn4E"};